(function () {
  const ROOT_SELECTOR = '.tl-custom-cart-goal-container';
  const DRAWER_SLOT_SELECTOR = '[data-cart-drawer-salepify]';
  const PDP_SLOT_SELECTOR = '[data-soul-pdp-progress]';
  const PRODUCT_CARD_CONTEXT_SELECTOR = 'product-card, .product-card';
  const MIRROR_CLASS = 'soul-prog';
  const MIRROR_ATTR = 'data-soul-prog-mirror';
  const SALEPIFY_HIDDEN_CLASS = 'soul-salepify-source-hidden';
  const MONEY_PATTERN = /(\d{1,3}(?:,\d{3})*|\d+)\.(\d{2})\s*BRL\b/g;
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT']);
  const STYLE_ID = 'soul-salepify-progress-styles';

  let observer;
  let scheduled = false;
  let running = false;
  let cartTotalCents = null;
  let cartFetchPromise = null;

  const STYLE_CONTENT = `
    product-card .tl-custom-cart-goal-container,
    .product-card .tl-custom-cart-goal-container,
    .tl-custom-cart-goal-container.soul-salepify-goal--product-card,
    .tl-custom-cart-goal-container.soul-salepify-goal--duplicate {
      display: none !important;
      visibility: hidden !important;
      width: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
      border: 0 !important;
      box-shadow: none !important;
    }

    ${DRAWER_SLOT_SELECTOR}:empty,
    ${PDP_SLOT_SELECTOR}:empty {
      display: none !important;
    }

    ${PDP_SLOT_SELECTOR}:not(:empty) {
      display: block !important;
      margin-top: 22px !important;
    }

    .${SALEPIFY_HIDDEN_CLASS} {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      border: 0 !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      overflow: hidden !important;
      pointer-events: none !important;
    }

    /* ===== Tek Labs (Salepify) widget — surgical redesign ===== */

    ${PDP_SLOT_SELECTOR} .tl-custom-cart-goal-container,
    ${DRAWER_SLOT_SELECTOR} .tl-custom-cart-goal-container {
      --tl__cart-goal__filled-bar-color: #263525;
      box-sizing: border-box !important;
      padding: 22px 22px 24px !important;
      background: #fffdf9 !important;
      border: 1px solid rgba(178, 119, 42, 0.28) !important;
      color: #263525 !important;
      font-family: Sora, var(--font-body--family), Arial, sans-serif !important;
      box-shadow: none !important;
    }

    ${DRAWER_SLOT_SELECTOR} .tl-custom-cart-goal-container {
      padding: 16px 14px 18px !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__container__drawer {
      display: block !important;
      width: 100% !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__reward-description__drawer {
      display: block !important;
      margin: 0 0 20px !important;
      padding: 0 !important;
      color: #263525 !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 1.32 !important;
      text-align: center !important;
      letter-spacing: 0 !important;
      text-transform: none !important;
    }

    ${DRAWER_SLOT_SELECTOR} .tl-custom-cart-goal-container .tl__cart-goal__reward-description__drawer {
      margin-bottom: 18px !important;
      font-size: 13px !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__goal-container__drawer {
      position: relative !important;
      display: block !important;
      width: calc(100% - 24px) !important;
      height: 6px !important;
      margin: 14px 12px 64px !important;
      background: #eadfce !important;
      border-radius: 999px !important;
      overflow: visible !important;
    }

    ${DRAWER_SLOT_SELECTOR} .tl-custom-cart-goal-container .tl__cart-goal__goal-container__drawer {
      margin: 10px 12px 52px !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__goal-process__drawer {
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      height: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      background: #263525 !important;
      border-radius: inherit !important;
      transition: width 400ms cubic-bezier(0.22, 1, 0.36, 1) !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__goal-check-point__drawer {
      position: absolute !important;
      top: 50% !important;
      left: 0 !important;
      display: grid !important;
      place-items: center !important;
      width: 22px !important;
      height: 22px !important;
      padding: 0 !important;
      gap: 0 !important;
      transform: translate(-50%, -50%) !important;
      border-radius: 999px !important;
      border-width: 1.5px !important;
      border-style: solid !important;
      z-index: 2 !important;
      overflow: visible !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__milestone-image {
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      width: 12px !important;
      height: 12px !important;
      max-width: none !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__goal-check-point-value,
    .tl-custom-cart-goal-container .tl__cart-goal__goal-check-point-title {
      position: absolute !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      width: max-content !important;
      max-width: 120px !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #263525 !important;
      line-height: 1.2 !important;
      text-align: center !important;
      white-space: nowrap !important;
      overflow: visible !important;
      text-overflow: clip !important;
      visibility: visible !important;
      pointer-events: none !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__goal-check-point-value {
      top: calc(100% + 10px) !important;
      bottom: auto !important;
      font-size: 11.5px !important;
      font-weight: 800 !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__goal-check-point-title {
      top: calc(100% + 28px) !important;
      bottom: auto !important;
      color: #665d53 !important;
      font-size: 10.5px !important;
      font-weight: 600 !important;
    }

    /* Last milestone: anchor labels to its right edge so they don't overflow the container */
    .tl-custom-cart-goal-container .tl__cart-goal__goal-check-point__drawer:last-child .tl__cart-goal__goal-check-point-value,
    .tl-custom-cart-goal-container .tl__cart-goal__goal-check-point__drawer:last-child .tl__cart-goal__goal-check-point-title {
      left: auto !important;
      right: 0 !important;
      transform: none !important;
      text-align: right !important;
    }

    /* Reward block */
    .tl-custom-cart-goal-container .tl__cart-goal__free-gift-container-1 {
      margin-top: 14px !important;
      padding: 12px 14px !important;
      background: #faf6ec !important;
      border: 1px solid rgba(38, 53, 37, 0.12) !important;
      color: #263525 !important;
    }

    ${DRAWER_SLOT_SELECTOR} .tl-custom-cart-goal-container .tl__cart-goal__free-gift-container-1 {
      padding: 10px 12px !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__free-gift-container-1 hr {
      display: none !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__free-gift-container-1 > div {
      align-items: center !important;
      gap: 12px !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__container-text-reward {
      margin: 0 !important;
      padding: 0 !important;
      color: #263525 !important;
      line-height: 1.32 !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__free-gift-container-1 .tl__cart-goal__container-text-reward:first-child {
      font-size: 13px !important;
      font-weight: 800 !important;
      line-height: 1.22 !important;
      color: #263525 !important;
    }

    .tl-custom-cart-goal-container .tl__cart-goal__free-gift-container-1 .tl__cart-goal__container-text-reward + .tl__cart-goal__container-text-reward {
      margin-top: 4px !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      color: #665d53 !important;
    }

    ${DRAWER_SLOT_SELECTOR} .tl-custom-cart-goal-container .tl__cart-goal__free-gift-container-1 .tl__cart-goal__container-text-reward:first-child {
      font-size: 11px !important;
    }

    ${DRAWER_SLOT_SELECTOR} .tl-custom-cart-goal-container .tl__cart-goal__free-gift-container-1 .tl__cart-goal__container-text-reward + .tl__cart-goal__container-text-reward {
      font-size: 10px !important;
    }

    @media screen and (max-width: 749px) {
      ${PDP_SLOT_SELECTOR} .tl-custom-cart-goal-container {
        padding: 18px 16px 20px !important;
      }

      .tl-custom-cart-goal-container .tl__cart-goal__reward-description__drawer {
        font-size: 14px !important;
        margin-bottom: 28px !important;
      }

      .tl-custom-cart-goal-container .tl__cart-goal__goal-check-point-value,
      .tl-custom-cart-goal-container .tl__cart-goal__goal-check-point-title {
        display: none !important;
      }
    }

    /* ===== Tek Labs (Salepify) volume discount ===== */

    #tl-discount-container {
      --soul-sale-accent: #263525;
      --soul-sale-accent-hover: #b2772a;
      --soul-sale-accent-soft: rgba(38, 53, 37, 0.12);
      --soul-sale-gold-soft: rgba(178, 119, 42, 0.28);
      --soul-sale-surface: #fffdf9;
      --soul-sale-surface-soft: #faf6ec;
      --soul-sale-muted: #665d53;
      --soul-sale-muted-soft: #8f867a;

      width: 100% !important;
      max-width: 100% !important;
      margin: 18px 0 22px !important;
      padding: 0 !important;
      background: transparent !important;
      border: 0 !important;
      border-radius: 0 !important;
      color: var(--soul-sale-accent) !important;
      font-family: Sora, var(--font-body--family), Arial, sans-serif !important;
      box-shadow: none !important;
    }

    #tl-discount-container *,
    #tl-discount-container *::before,
    #tl-discount-container *::after {
      box-sizing: border-box !important;
      font-family: inherit !important;
      letter-spacing: 0 !important;
    }

    #tl-discount-container .tl-discount-tier-container {
      width: 100% !important;
      max-width: none !important;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 1.25 !important;
    }

    #tl-discount-container .tl-discount-title {
      justify-content: center !important;
      gap: 10px !important;
      margin: 0 0 14px !important;
      color: var(--soul-sale-accent) !important;
      font-size: 15px !important;
      font-weight: 800 !important;
      line-height: 1.2 !important;
      text-align: center !important;
      text-transform: none !important;
    }

    #tl-discount-container .tl-discount-title::before,
    #tl-discount-container .tl-discount-title::after {
      content: '' !important;
      flex: 1 1 36px !important;
      max-width: 72px !important;
      height: 1px !important;
      background: var(--soul-sale-gold-soft) !important;
    }

    #tl-discount-container .tl-list-discount-tier {
      display: grid !important;
      gap: 10px !important;
    }

    #tl-discount-container .label-tl-discount,
    #tl-discount-container .selected-label-tl-discount {
      display: block !important;
      position: relative !important;
      margin: 0 !important;
      border: 0 !important;
      cursor: pointer !important;
    }

    #tl-discount-container .tl-discount-rule-info {
      max-width: 100% !important;
      min-width: 0 !important;
      overflow: visible !important;
      background: var(--soul-sale-surface) !important;
      border: 1px solid var(--soul-sale-gold-soft) !important;
      border-radius: 0 !important;
      color: var(--soul-sale-accent) !important;
      box-shadow: none !important;
      transition: border-color 180ms ease, background 180ms ease !important;
    }

    #tl-discount-container .selected-label-tl-discount .tl-discount-rule-info,
    #tl-discount-container .tl-discount-rule-info.tl-selected-tier {
      background: var(--soul-sale-surface-soft) !important;
      border: 2px solid var(--soul-sale-accent) !important;
    }

    #tl-discount-container .tl-flex-wrapper {
      min-height: 76px !important;
      padding: 14px 16px !important;
      max-width: 100% !important;
      min-width: 0 !important;
    }

    #tl-discount-container .tl-discount-tier-amount-infor {
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      gap: 14px !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
    }

    #tl-discount-container .tl-discount-tier-amount-infor > div:first-child {
      min-width: 0 !important;
    }

    #tl-discount-container .tl-display-flex {
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      min-width: 0 !important;
      flex-wrap: wrap !important;
    }

    #tl-discount-container .tl-discount-image-container,
    #tl-discount-container .tl-discount-variant-image-container {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex: 0 0 46px !important;
      width: 46px !important;
      height: 46px !important;
      margin: 0 4px 0 0 !important;
      padding: 3px !important;
      overflow: hidden !important;
      border: 1px solid var(--soul-sale-accent-soft) !important;
      border-radius: 0 !important;
      background: var(--soul-sale-surface) !important;
    }

    #tl-discount-container .tl-discount-product-image {
      width: 100% !important;
      height: 100% !important;
      aspect-ratio: 1 / 1 !important;
      object-fit: contain !important;
    }

    #tl-discount-container .tl-discount-tier-info,
    #tl-discount-container .tl-discount-tier-info p,
    #tl-discount-container .tl-discount-tier-info span {
      color: var(--soul-sale-accent) !important;
      font-size: 14px !important;
      font-weight: 800 !important;
      line-height: 1.15 !important;
      text-transform: uppercase !important;
      overflow-wrap: anywhere !important;
    }

    #tl-discount-container .tl-discount-label {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      min-height: 21px !important;
      padding: 3px 7px !important;
      border-radius: 999px !important;
      background: rgba(178, 119, 42, 0.14) !important;
      color: var(--soul-sale-accent) !important;
      font-size: 11px !important;
      font-weight: 800 !important;
      line-height: 1 !important;
      text-transform: uppercase !important;
      white-space: nowrap !important;
    }

    #tl-discount-container .tl-discount-tier-price-container {
      display: flex !important;
      flex: 0 0 auto !important;
      flex-direction: column !important;
      align-items: flex-end !important;
      min-width: 90px !important;
      text-align: right !important;
    }

    #tl-discount-container .tl-discount-tier-price {
      color: var(--soul-sale-accent-hover) !important;
      font-size: 15px !important;
      font-weight: 800 !important;
      line-height: 1.12 !important;
      white-space: nowrap !important;
    }

    #tl-discount-container .tl-discount-tier-regular-price {
      width: auto !important;
      margin-top: 4px !important;
      color: var(--soul-sale-muted-soft) !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      line-height: 1.1 !important;
      text-align: right !important;
      white-space: nowrap !important;
      text-decoration-color: currentColor !important;
    }

    #tl-discount-container .tl-discount-tag {
      top: -12px !important;
      left: 16px !important;
      height: 24px !important;
      padding: 0 12px !important;
      background: var(--soul-sale-accent) !important;
      color: var(--soul-sale-surface) !important;
      border-radius: 0 !important;
      font-size: 12px !important;
      font-weight: 800 !important;
      line-height: 24px !important;
      white-space: nowrap !important;
    }

    #tl-discount-container .tl-discount-tag::before,
    #tl-discount-container .tl-discount-tag::after {
      display: none !important;
    }

    #tl-discount-container .tl-discounts-grab-button {
      position: static !important;
      left: auto !important;
      bottom: auto !important;
      display: none !important;
      width: 100% !important;
      margin: 10px 0 0 !important;
      transform: none !important;
      justify-content: stretch !important;
    }

    #tl-discount-container .selected-label-tl-discount .tl-discounts-grab-button {
      display: flex !important;
    }

    #tl-discount-container .tl-discounts-grab-button-link {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      min-height: 44px !important;
      padding: 0 16px !important;
      background: var(--soul-sale-accent) !important;
      border: 1px solid var(--soul-sale-accent) !important;
      border-radius: 0 !important;
      color: var(--soul-sale-surface) !important;
      box-shadow: none !important;
      font-size: 13px !important;
      font-weight: 800 !important;
      line-height: 1 !important;
      text-decoration: none !important;
      text-transform: uppercase !important;
      transition: background 180ms ease, border-color 180ms ease !important;
    }

    #tl-discount-container .tl-discounts-grab-button-link:hover {
      background: var(--soul-sale-accent-hover) !important;
      border-color: var(--soul-sale-accent-hover) !important;
      color: var(--soul-sale-surface) !important;
      box-shadow: none !important;
    }

    #tl-discount-container .tl-discount-option-container,
    #tl-discount-container .tl-list-free-gift {
      background: var(--soul-sale-surface-soft) !important;
      border-color: var(--soul-sale-gold-soft) !important;
      border-radius: 0 !important;
    }

    #tl-discount-container .tl-list-free-gift {
      border-width: 1px !important;
      border-style: solid !important;
    }

    #tl-discount-container .tl-select-variant-button,
    #tl-discount-container .tl-variants-choice-list select {
      border: 1px solid var(--soul-sale-gold-soft) !important;
      border-radius: 0 !important;
      color: var(--soul-sale-accent) !important;
      background: var(--soul-sale-surface) !important;
      box-shadow: none !important;
    }

    @media screen and (max-width: 749px) {
      #tl-discount-container {
        align-self: stretch !important;
        width: 100% !important;
        max-width: 100% !important;
        margin: 16px 0 22px !important;
      }

      #tl-discount-container .tl-discount-title {
        gap: 8px !important;
        margin-bottom: 14px !important;
        font-size: 15px !important;
        line-height: 1.22 !important;
      }

      #tl-discount-container .tl-discount-title::before,
      #tl-discount-container .tl-discount-title::after {
        min-width: 42px !important;
        max-width: none !important;
      }

      #tl-discount-container .tl-list-discount-tier {
        gap: 10px !important;
      }

      #tl-discount-container .tl-flex-wrapper {
        min-height: 74px !important;
        padding: 12px 13px !important;
      }

      #tl-discount-container .tl-discount-tier-amount-infor {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        gap: 10px !important;
      }

      #tl-discount-container .tl-display-flex {
        gap: 6px 7px !important;
        flex-wrap: wrap !important;
      }

      #tl-discount-container .tl-discount-image-container,
      #tl-discount-container .tl-discount-variant-image-container {
        flex: 0 0 38px !important;
        width: 38px !important;
        height: 38px !important;
        margin-right: 2px !important;
      }

      #tl-discount-container .tl-discount-tier-info,
      #tl-discount-container .tl-discount-tier-info p,
      #tl-discount-container .tl-discount-tier-info span {
        font-size: 12.5px !important;
        line-height: 1.12 !important;
        white-space: nowrap !important;
      }

      #tl-discount-container .tl-discount-label {
        min-height: 20px !important;
        padding: 4px 7px !important;
        font-size: 10px !important;
      }

      #tl-discount-container .tl-discount-tier-price-container {
        flex: 0 0 auto !important;
        min-width: 82px !important;
        max-width: 100% !important;
        margin-left: 0 !important;
        align-items: flex-end !important;
        text-align: right !important;
      }

      #tl-discount-container .tl-discount-tier-price {
        max-width: 100% !important;
        font-size: 14px !important;
        line-height: 1.12 !important;
        text-align: right !important;
      }

      #tl-discount-container .tl-discount-tier-regular-price {
        max-width: 100% !important;
        font-size: 11px !important;
        line-height: 1.1 !important;
        text-align: right !important;
      }

      #tl-discount-container .tl-discounts-grab-button {
        margin-top: 8px !important;
      }

      #tl-discount-container .tl-discounts-grab-button-link {
        min-height: 42px !important;
        font-size: 12px !important;
      }

      #tl-discount-container .tl-discount-tag {
        left: 12px !important;
        height: 22px !important;
        padding: 0 10px !important;
        font-size: 11px !important;
        line-height: 22px !important;
      }
    }

    .${MIRROR_CLASS} {
      --soul-prog-accent: #263525;
      --soul-prog-accent-soft: rgba(38, 53, 37, 0.12);
      --soul-prog-track: #eadfce;
      --soul-prog-surface: #fffdf9;
      --soul-prog-card: #faf6ec;
      --soul-prog-text: #263525;
      --soul-prog-muted: #665d53;
      --soul-prog-gold: #b2772a;
      --soul-prog-gold-soft: rgba(178, 119, 42, 0.28);

      display: block;
      box-sizing: border-box;
      width: 100%;
      padding: 22px 22px 24px;
      border: 1px solid var(--soul-prog-gold-soft);
      background: var(--soul-prog-surface);
      color: var(--soul-prog-text);
      font-family: Sora, var(--font-body--family), Arial, sans-serif;
    }

    .${MIRROR_CLASS} *,
    .${MIRROR_CLASS} *::before,
    .${MIRROR_CLASS} *::after {
      box-sizing: border-box;
      font-family: inherit;
    }

    .${MIRROR_CLASS}__message {
      display: block;
      margin: 0 0 30px;
      color: var(--soul-prog-text);
      font-size: 15px;
      font-weight: 700;
      line-height: 1.32;
      text-align: center;
      text-wrap: pretty;
    }

    .${MIRROR_CLASS}__track {
      position: relative;
      width: calc(100% - 28px);
      height: 6px;
      margin: 0 auto 56px;
      background: var(--soul-prog-track);
      border-radius: 999px;
    }

    .${MIRROR_CLASS}__fill {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: var(--soul-prog, 0%);
      max-width: 100%;
      background: var(--soul-prog-accent);
      border-radius: inherit;
      transition: width 360ms cubic-bezier(0.22, 1, 0.36, 1);
    }

    .${MIRROR_CLASS}__milestone {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(-50%, -50%);
      display: grid;
      place-items: center;
      width: 26px;
      height: 26px;
      border-radius: 999px;
      border: 2px solid var(--soul-prog-accent);
      background: var(--soul-prog-surface);
      color: var(--soul-prog-accent);
      z-index: 1;
      transition: background 220ms ease, transform 220ms ease, color 220ms ease;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    }

    .${MIRROR_CLASS}__milestone.is-unlocked {
      background: var(--soul-prog-accent);
      color: var(--soul-prog-surface);
    }

    .${MIRROR_CLASS}__milestone-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }

    .${MIRROR_CLASS}__milestone-icon svg {
      width: 14px;
      height: 14px;
      display: block;
    }

    .${MIRROR_CLASS}__milestone[data-edge='start'] {
      transform: translate(0, -50%);
    }

    .${MIRROR_CLASS}__milestone[data-edge='end'] {
      transform: translate(-100%, -50%);
    }

    .${MIRROR_CLASS}__milestone-value,
    .${MIRROR_CLASS}__milestone-label {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: max-content;
      max-width: 120px;
      color: var(--soul-prog-text);
      font-size: 11px;
      font-weight: 700;
      line-height: 1.2;
      text-align: center;
      white-space: normal;
      pointer-events: none;
    }

    .${MIRROR_CLASS}__milestone-value {
      bottom: calc(100% + 10px);
      font-size: 12px;
      font-weight: 800;
    }

    .${MIRROR_CLASS}__milestone-label {
      top: calc(100% + 10px);
      color: var(--soul-prog-muted);
      font-weight: 600;
    }

    .${MIRROR_CLASS}__milestone[data-edge='start'] .${MIRROR_CLASS}__milestone-value,
    .${MIRROR_CLASS}__milestone[data-edge='start'] .${MIRROR_CLASS}__milestone-label {
      left: 0;
      transform: none;
      text-align: left;
    }

    .${MIRROR_CLASS}__milestone[data-edge='end'] .${MIRROR_CLASS}__milestone-value,
    .${MIRROR_CLASS}__milestone[data-edge='end'] .${MIRROR_CLASS}__milestone-label {
      left: auto;
      right: 0;
      transform: none;
      text-align: right;
    }

    .${MIRROR_CLASS}__rewards {
      display: grid;
      gap: 10px;
    }

    .${MIRROR_CLASS}__reward {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 14px;
      align-items: center;
      padding: 14px 16px;
      background: var(--soul-prog-card);
      border: 1px solid var(--soul-prog-accent-soft);
    }

    .${MIRROR_CLASS}__reward-copy {
      display: grid;
      gap: 3px;
      min-width: 0;
    }

    .${MIRROR_CLASS}__reward-copy strong {
      color: var(--soul-prog-text);
      font-size: 13px;
      font-weight: 800;
      line-height: 1.22;
    }

    .${MIRROR_CLASS}__reward-copy span {
      color: var(--soul-prog-muted);
      font-size: 12px;
      line-height: 1.34;
    }

    .${MIRROR_CLASS}__reward-status {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      min-height: 34px;
      padding: 8px 14px;
      background: var(--soul-prog-surface);
      border: 1px solid var(--soul-prog-accent-soft);
      color: var(--soul-prog-muted);
      font-size: 11px;
      font-weight: 800;
      letter-spacing: 0.02em;
      line-height: 1;
      text-align: center;
      text-transform: uppercase;
      white-space: nowrap;
    }

    .${MIRROR_CLASS}__reward.is-unlocked .${MIRROR_CLASS}__reward-status {
      background: var(--soul-prog-accent);
      border-color: var(--soul-prog-accent);
      color: var(--soul-prog-surface);
    }

    .${MIRROR_CLASS}__reward.is-unlocked .${MIRROR_CLASS}__reward-status::before {
      content: '';
      display: inline-block;
      width: 12px;
      height: 12px;
      mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='currentColor' d='M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z'/></svg>") no-repeat center / contain;
      -webkit-mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='currentColor' d='M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z'/></svg>") no-repeat center / contain;
      background: currentColor;
    }

    .${MIRROR_CLASS}--drawer {
      padding: 14px 14px 16px;
      border: none;
      border-bottom: 1px solid var(--soul-prog-gold-soft);
      background: transparent;
    }

    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__message {
      margin-bottom: 16px;
      font-size: 13px;
    }

    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__track {
      width: calc(100% - 16px);
      margin-bottom: 12px;
    }

    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__milestone-value,
    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__milestone-label {
      display: none;
    }

    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__rewards {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
    }

    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__reward {
      display: block;
      border: none;
      padding: 12px 0;
      margin: 0;
      border-bottom: 1px solid #C4C4C4;
      border-radius: 0;
    }

    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__reward:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__reward-copy strong {
      font-size: 15px;
      color: #2D3A2C;
      display: block;
      margin-bottom: 6px;
      line-height: 1.2;
    }

    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__reward-copy span {
      font-size: 13px;
      color: #4A4A4A;
      line-height: 1.3;
    }

    .${MIRROR_CLASS}--drawer .${MIRROR_CLASS}__reward-status {
      display: none;
    }

    @media screen and (max-width: 749px) {
      .${MIRROR_CLASS} {
        padding: 18px 16px 20px;
      }

      .${MIRROR_CLASS}__message {
        margin-bottom: 26px;
        font-size: 14px;
      }

      .${MIRROR_CLASS}__track {
        width: calc(100% - 16px);
        margin-bottom: 44px;
      }

      .${MIRROR_CLASS}__milestone-value,
      .${MIRROR_CLASS}__milestone-label {
        display: none;
      }

      .${MIRROR_CLASS}__reward {
        padding: 12px 14px;
      }

      .${MIRROR_CLASS}__reward-copy strong {
        font-size: 12px;
      }

      .${MIRROR_CLASS}__reward-copy span {
        font-size: 11px;
      }
    }

    /* Cart Drawer UX Optimizations */
    .cart-drawer .cart-items__title,
    cart-drawer-component .cart-items__title {
      display: -webkit-box !important;
      -webkit-line-clamp: 2 !important;
      -webkit-box-orient: vertical !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      font-size: 13px !important;
      line-height: 1.2 !important;
    }

    /* 2-Scrollers Fix */
    .cart-drawer__dialog {
      overflow: hidden !important;
    }
    .cart-drawer__inner {
      overflow: hidden !important;
      display: flex !important;
      flex-direction: column !important;
      max-height: 100vh !important;
    }
    .cart-drawer__content {
      flex: 1 !important;
      display: flex !important;
      flex-direction: column !important;
      min-height: 0 !important;
    }
    .cart-drawer__items {
      flex: 1 !important;
      overflow-y: auto !important;
      min-height: 0 !important;
    }
    .cart-drawer__summary,
    .cart-totals {
      overflow-y: visible !important;
    }

    .cart-drawer button[name="checkout"],
    cart-drawer-component button[name="checkout"],
    .cart__checkout-button {
      animation: soulPulse 2s infinite ease-in-out !important;
    }

    @keyframes soulPulse {
      0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(62, 140, 66, 0.4); }
      50% { transform: scale(1.02); box-shadow: 0 0 0 8px rgba(62, 140, 66, 0); }
      100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(62, 140, 66, 0); }
    }
  `;

  function injectStyles() {
    let style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
    }
    if (style.textContent !== STYLE_CONTENT) {
      style.textContent = STYLE_CONTENT;
    }
    if (!style.parentElement) {
      document.head.appendChild(style);
    }
  }

  function formatBrazilianMoney(text) {
    return text.replace(MONEY_PATTERN, (_, integerPart, cents) => {
      const reais = integerPart.replace(/,/g, '.');
      return `R$ ${reais},${cents}`;
    });
  }

  function polishText(root) {
    if (!(root.textContent || '').includes('BRL')) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || SKIP_TAGS.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return node.nodeValue && node.nodeValue.includes('BRL')
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const formatted = formatBrazilianMoney(node.nodeValue);
      if (formatted !== node.nodeValue) node.nodeValue = formatted;
    });
  }

  function isProductCardGoal(root) {
    return root instanceof HTMLElement && Boolean(root.closest(PRODUCT_CARD_CONTEXT_SELECTOR));
  }

  function isDrawerGoal(root) {
    return root instanceof HTMLElement && Boolean(root.closest(DRAWER_SLOT_SELECTOR) || root.closest('cart-drawer-component'));
  }

  function isPdpGoal(root) {
    return root instanceof HTMLElement && Boolean(root.closest(PDP_SLOT_SELECTOR) || root.closest('.product-information'));
  }

  function isCartPageGoal(root) {
    return root instanceof HTMLElement && Boolean(root.closest('.cart-page'));
  }

  function slot(selector) {
    const node = document.querySelector(selector);
    return node instanceof HTMLElement ? node : null;
  }

  function makePrimary(root) {
    root.hidden = false;
    root.removeAttribute('aria-hidden');
    root.classList.remove('soul-salepify-goal--duplicate', 'soul-salepify-goal--product-card');
  }

  function hideDuplicate(root) {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    root.classList.add('soul-salepify-goal--duplicate');
  }

  function normalizeProductCardRoots(roots) {
    roots.forEach((root) => {
      if (!isProductCardGoal(root)) return;
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      root.classList.add('soul-salepify-goal--product-card');
    });
  }

  function normalizeSlotRoots(roots, selector, predicate) {
    const target = slot(selector);
    if (!target) return null;

    const candidates = roots.filter((root) => (
      root instanceof HTMLElement &&
      !isProductCardGoal(root) &&
      predicate(root)
    ));

    if (!candidates.length) return null;

    const primary = candidates.find((root) => root.parentElement === target) || candidates[0];
    makePrimary(primary);

    if (primary.parentElement !== target) {
      target.prepend(primary);
    }

    candidates.forEach((root) => {
      if (root !== primary) hideDuplicate(root);
    });

    return primary;
  }

  function placeGoals(roots) {
    normalizeProductCardRoots(roots);

    const pdpPrimary = normalizeSlotRoots(
      roots,
      PDP_SLOT_SELECTOR,
      (root) => isPdpGoal(root) && !isDrawerGoal(root)
    );

    const drawerPrimary = normalizeSlotRoots(
      roots,
      DRAWER_SLOT_SELECTOR,
      (root) => isDrawerGoal(root) && root !== pdpPrimary
    );

    roots.forEach((root) => {
      if (!(root instanceof HTMLElement) || isProductCardGoal(root)) return;
      if (root === pdpPrimary || root === drawerPrimary) return;
      if (isPdpGoal(root) || isDrawerGoal(root)) hideDuplicate(root);
    });

    const cartPageCandidates = roots.filter((root) => (
      root instanceof HTMLElement &&
      !isProductCardGoal(root) &&
      root !== pdpPrimary &&
      root !== drawerPrimary &&
      isCartPageGoal(root)
    ));

    const cartPagePrimary = cartPageCandidates[0] || null;
    if (cartPagePrimary) makePrimary(cartPagePrimary);

    cartPageCandidates.forEach((root) => {
      if (root !== cartPagePrimary) hideDuplicate(root);
    });

    return { pdpPrimary, drawerPrimary, cartPagePrimary };
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseMoneyToCents(value) {
    const text = String(value || '');
    const match = text.match(/(?:R\$\s*)?(\d{1,3}(?:\.\d{3})*|\d+)(?:,(\d{2}))?/);
    if (!match) return null;

    const reais = match[1].replace(/\./g, '');
    const cents = match[2] || '00';
    const amount = Number.parseInt(reais, 10) * 100 + Number.parseInt(cents, 10);
    return Number.isFinite(amount) ? amount : null;
  }

  function formatMoneyFromCents(cents) {
    const value = Math.max(0, Math.round(Number(cents) || 0)) / 100;
    return `R$ ${value.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  function getCartUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/?$/, '/') }cart.js`;
  }

  function refreshCartTotal() {
    if (cartFetchPromise) return cartFetchPromise;

    cartFetchPromise = fetch(getCartUrl(), {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to fetch cart');
        return response.json();
      })
      .then((cart) => {
        const nextTotal = Number.isFinite(cart?.total_price) ? cart.total_price : null;
        if (nextTotal !== null && nextTotal !== cartTotalCents) {
          cartTotalCents = nextTotal;
          schedule();
        }
      })
      .catch(() => {})
      .finally(() => {
        cartFetchPromise = null;
      });

    return cartFetchPromise;
  }

  function findFirstWithStyle(root, prop) {
    const all = root.querySelectorAll('*');
    for (const el of all) {
      if (el.style && el.style[prop]) {
        return el;
      }
    }
    return null;
  }

  function findAllWithStyle(root, prop) {
    const result = [];
    const all = root.querySelectorAll('*');
    for (const el of all) {
      if (el.style && el.style[prop]) {
        result.push(el);
      }
    }
    return result;
  }

  function parseCheckpointMilestones(root) {
    const checkpoints = Array.from(root.querySelectorAll('.tl__cart-goal__goal-check-point__drawer'));
    const milestones = [];
    const seen = new Set();

    checkpoints.forEach((el) => {
      const valueText = (
        el.querySelector('.tl__cart-goal__goal-check-point-value')?.textContent ||
        (el.textContent || '').match(/R\$\s*[\d.,]+/)?.[0] ||
        ''
      ).replace(/\s+/g, ' ').trim();

      const amountCents = parseMoneyToCents(valueText);
      if (!amountCents || seen.has(amountCents)) return;
      seen.add(amountCents);

      let label = (
        el.querySelector('.tl__cart-goal__goal-check-point-title')?.textContent ||
        (el.textContent || '').replace(valueText, '')
      ).replace(/\s+/g, ' ').trim();

      label = label.replace(/^[-–•·\s]+|[-–•·\s]+$/g, '');

      milestones.push({
        value: valueText || formatMoneyFromCents(amountCents),
        label,
        amountCents,
        percent: 0,
        unlocked: false,
      });
    });

    if (!milestones.length) return [];

    const maxGoal = Math.max(...milestones.map((milestone) => milestone.amountCents));
    return milestones
      .sort((a, b) => a.amountCents - b.amountCents)
      .map((milestone) => ({
        ...milestone,
        percent: Math.max(0, Math.min(100, (milestone.amountCents / maxGoal) * 100)),
      }));
  }

  function applyRealCartTotal(data) {
    if (!data?.milestones?.length || cartTotalCents === null) return data;

    const milestones = data.milestones
      .filter((milestone) => Number.isFinite(milestone.amountCents) && milestone.amountCents > 0)
      .sort((a, b) => a.amountCents - b.amountCents);

    if (!milestones.length) return data;

    const maxGoal = milestones[milestones.length - 1].amountCents;
    const nextMilestone = milestones.find((milestone) => cartTotalCents < milestone.amountCents);

    data.progress = Math.max(0, Math.min(100, (cartTotalCents / maxGoal) * 100));
    data.milestones = milestones.map((milestone) => ({
      ...milestone,
      percent: Math.max(0, Math.min(100, (milestone.amountCents / maxGoal) * 100)),
      unlocked: cartTotalCents >= milestone.amountCents,
    }));

    if (nextMilestone) {
      const remaining = nextMilestone.amountCents - cartTotalCents;
      data.message = `Faltam só ${formatMoneyFromCents(remaining)} para você ganhar ${nextMilestone.label || 'este benefício'}.`;
    } else {
      data.message = 'Parabéns! Você desbloqueou todos os brindes 🎉';
    }

    data.rewards = data.milestones.map((milestone) => {
      const isShipping = (milestone.label || '').toLowerCase().includes('frete');
      const remaining = Math.max(0, milestone.amountCents - cartTotalCents);
      return {
        title: milestone.label || milestone.value,
        body: milestone.unlocked
          ? (isShipping ? 'Frete Grátis desbloqueado!' : 'Parabéns! Você desbloqueou o brinde!')
          : `Faltam só ${formatMoneyFromCents(remaining)} para você ganhar ${milestone.label || 'este benefício'}.`,
        unlocked: milestone.unlocked,
      };
    });

    return data;
  }

  function parseSalepifyData(root) {
    const data = {
      message: '',
      progress: 0,
      milestones: [],
      rewards: [],
    };

    const text = (root.textContent || '').replace(/\s+/g, ' ').trim();

    // 1. Message: extract directly from element if possible
    const msgEl = root.querySelector('[class*="reward-description"]');
    if (msgEl) {
      data.message = (msgEl.textContent || '').trim();
    } else {
      // Fallback regex
      const msgPatterns = [
        /Faltam\s+só\s+R\$\s*[\d.,]+\s+para\s+você\s+(?:ganhar|desbloquear|garantir)\s+[^.!]+[.!]?/i,
        /Parabéns![^!.]{0,80}[.!]/i,
        /Você\s+desbloqueou\s+[^.!]+[.!]?/i,
      ];
      for (const re of msgPatterns) {
        const m = text.match(re);
        if (m) {
          data.message = m[0].trim();
          break;
        }
      }
    }

    // 2. Progress fill
    const fillEl = root.querySelector('.tl__cart-goal__goal-process__drawer, .tl__cart-goal__goal-process, [class*="goal-process"]');
    if (fillEl && fillEl.style && fillEl.style.width) {
      data.progress = Math.max(0, Math.min(100, parseFloat(fillEl.style.width) || 0));
    } else {
      const widthEls = findAllWithStyle(root, 'width').filter((el) => {
        const w = el.style.width || '';
        return w.endsWith('%') && !el.style.left;
      });
      if (widthEls.length) {
        let best = widthEls[0];
        let bestPct = parseFloat(best.style.width);
        for (const el of widthEls) {
          const p = parseFloat(el.style.width);
          if (!isNaN(p) && p >= 0 && p <= 100 && p > bestPct - 0.001) {
            if (el.children.length <= best.children.length) {
              best = el;
              bestPct = p;
            }
          }
        }
        data.progress = Math.max(0, Math.min(100, bestPct));
      }
    }

    // 3. Milestones
    data.milestones = parseCheckpointMilestones(root);

    if (!data.milestones.length) {
      const leftEls = findAllWithStyle(root, 'left').filter((el) => {
        const l = el.style.left || '';
        return l.endsWith('%');
      });

      const seenPercents = new Set();
      leftEls
        .map((el) => ({ el, percent: parseFloat(el.style.left) }))
        .filter((item) => !isNaN(item.percent) && item.percent >= 0 && item.percent <= 100)
        .sort((a, b) => a.percent - b.percent)
        .forEach(({ el, percent }) => {
          const key = Math.round(percent * 10) / 10;
          if (seenPercents.has(key)) return;
          seenPercents.add(key);

          const localText = (el.textContent || '').replace(/\s+/g, ' ').trim();
          const moneyMatch = localText.match(/R\$\s*[\d.,]+/);
          const value = moneyMatch ? moneyMatch[0] : '';
          let label = value ? localText.replace(value, '').trim() : localText;
          label = label.replace(/^[-–•·\s]+|[-–•·\s]+$/g, '');

          const unlocked = percent <= data.progress + 0.5;
          data.milestones.push({ value, label, percent, unlocked, amountCents: parseMoneyToCents(value) });
        });
    }

    // 4. Rewards: extract cleanly from DOM structure
    data.rewards = [];
    const rewardWrapper = root.querySelector('[class*="free-gift-container"]');
    if (rewardWrapper) {
      const rewardDivs = Array.from(rewardWrapper.children).filter(child => child.tagName === 'DIV');
      rewardDivs.forEach(div => {
        const pTags = div.querySelectorAll('p[class*="container-text-reward"]');
        if (pTags.length >= 2) {
          data.rewards.push({
            title: (pTags[0].textContent || '').trim(),
            body: (pTags[1].textContent || '').trim(),
            unlocked: true
          });
        } else {
          const strong = div.querySelector('strong, b');
          if (strong) {
            const title = (strong.textContent || '').trim();
            const body = (div.textContent || '').replace(title, '').trim();
            data.rewards.push({ title, body, unlocked: true });
          }
        }
      });
    }

    return applyRealCartTotal(data);
  }

  function buildMirrorHtml(data, context) {
    const ICON_CHECK = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
    const ICON_GIFT = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>`;
    const ICON_TRUCK = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>`;

    const contextClass = context === 'drawer' ? `${MIRROR_CLASS}--drawer` : `${MIRROR_CLASS}--pdp`;
    const milestones = data.milestones.map((m) => {
      let edge = '';
      if (m.percent <= 2) edge = 'start';
      else if (m.percent >= 98) edge = 'end';
      const valueHtml = m.value
        ? `<span class="${MIRROR_CLASS}__milestone-value">${escapeHtml(m.value)}</span>`
        : '';
      const labelHtml = m.label
        ? `<span class="${MIRROR_CLASS}__milestone-label">${escapeHtml(m.label)}</span>`
        : '';

      let iconSvg = ICON_GIFT;
      if (m.label && m.label.toLowerCase().includes('frete')) {
        iconSvg = ICON_TRUCK;
      }
      
      const iconHtml = `<span class="${MIRROR_CLASS}__milestone-icon">${iconSvg}</span>`;

      return `<span class="${MIRROR_CLASS}__milestone ${m.unlocked ? 'is-unlocked' : ''}" style="left: ${m.percent}%" ${edge ? `data-edge="${edge}"` : ''}>${iconHtml}${valueHtml}${labelHtml}</span>`;
    }).join('');

    const rewards = data.rewards.length
      ? `<div class="${MIRROR_CLASS}__rewards">${data.rewards.map((r) => `
          <div class="${MIRROR_CLASS}__reward ${r.unlocked ? 'is-unlocked' : ''}">
            <div class="${MIRROR_CLASS}__reward-copy">
              ${r.title ? `<strong>${escapeHtml(r.title)}</strong>` : ''}
              ${r.body ? `<span>${escapeHtml(r.body)}</span>` : ''}
            </div>
            <span class="${MIRROR_CLASS}__reward-status">${r.unlocked ? 'Resgatado' : 'Em breve'}</span>
          </div>`).join('')}</div>`
      : '';

    return `
      <div class="${MIRROR_CLASS} ${contextClass}" ${MIRROR_ATTR}="${context}">
        ${data.message ? `<p class="${MIRROR_CLASS}__message">${escapeHtml(data.message)}</p>` : ''}
        <div class="${MIRROR_CLASS}__track" style="--soul-prog: ${data.progress}%">
          <div class="${MIRROR_CLASS}__fill"></div>
          ${milestones}
        </div>
        ${rewards}
      </div>
    `;
  }

  function renderMirror(salepifyRoot, context) {
    if (!(salepifyRoot instanceof HTMLElement)) return;
    const data = parseSalepifyData(salepifyRoot);

    // If we couldn't extract anything meaningful, do not mirror (leave Salepify visible as-is)
    const hasData = data.message || data.milestones.length > 0 || data.rewards.length > 0 || data.progress > 0;
    if (!hasData) return;

    const parent = salepifyRoot.parentElement;
    if (!parent) return;

    const existingMirror = parent.querySelector(`:scope > [${MIRROR_ATTR}]`);
    const html = buildMirrorHtml(data, context).trim();

    if (existingMirror) {
      // Replace mirror if changed
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const fresh = tmp.firstElementChild;
      if (fresh) parent.replaceChild(fresh, existingMirror);
    } else {
      salepifyRoot.insertAdjacentHTML('beforebegin', html);
    }

    // Hide the Salepify source so only our mirror is visible (keeps data accessible to its own JS)
    salepifyRoot.classList.add(SALEPIFY_HIDDEN_CLASS);
  }

  function run() {
    if (running) return;
    refreshCartTotal();

    const roots = Array.from(document.querySelectorAll(ROOT_SELECTOR));
    injectStyles();

    if (!roots.length) return;

    running = true;
    observer?.disconnect();

    try {
      const { pdpPrimary, drawerPrimary, cartPagePrimary } = placeGoals(roots);
      roots.forEach(polishText);
      
      if (pdpPrimary) renderMirror(pdpPrimary, 'pdp');
      if (drawerPrimary) renderMirror(drawerPrimary, 'drawer');
      if (cartPagePrimary) renderMirror(cartPagePrimary, 'cart');
      
    } finally {
      running = false;
      observe();
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  }

  function nodeIsCartGoalContext(node) {
    if (!(node instanceof Element)) return false;
    return Boolean(
      node.matches(ROOT_SELECTOR) ||
      node.closest(ROOT_SELECTOR) ||
      node.matches(DRAWER_SLOT_SELECTOR) ||
      node.closest(DRAWER_SLOT_SELECTOR) ||
      node.matches(PDP_SLOT_SELECTOR) ||
      node.closest(PDP_SLOT_SELECTOR)
    );
  }

  function nodeContainsCartGoal(node) {
    if (!(node instanceof Element)) return false;
    return Boolean(
      nodeIsCartGoalContext(node) ||
      node.querySelector(ROOT_SELECTOR) ||
      node.querySelector(DRAWER_SLOT_SELECTOR) ||
      node.querySelector(PDP_SLOT_SELECTOR)
    );
  }

  function shouldHandleMutations(mutations) {
    return mutations.some((mutation) => {
      if (nodeIsCartGoalContext(mutation.target)) return true;
      return Array.from(mutation.addedNodes).some(nodeContainsCartGoal) ||
        Array.from(mutation.removedNodes).some(nodeContainsCartGoal);
    });
  }

  function observe() {
    const target = document.body || document.documentElement;
    if (!target || !observer) return;
    observer.observe(target, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  [250, 800, 1600, 3000, 6000].forEach((delay) => window.setTimeout(run, delay));

  observer = new MutationObserver((mutations) => {
    if (shouldHandleMutations(mutations)) schedule();
  });
  observe();
})();
